__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/78728f4/_next/";